// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { Menu, X, ChevronDown } from "lucide-react";

// import logo from "../Images/Konn3ct Images/Konn3ct_lo-removed.png";
// import FacebookIcon from "../Images/Konn3ct Images/facebook-02.png";
// import TwitterIcon from "../Images/Konn3ct Images/new-twitter.png";
// import LinkedInIcon from "../Images/Konn3ct Images/linkedin-01.png";
// import InstagramIcon from "../Images/Konn3ct Images/instagram.png";
// import YouTubeIcon from "../Images/Konn3ct Images/youtube.png";
// import AppleIcon from "../Images/Konn3ct Images/apple.png";
// import PlayStoreIcon from "../Images/Konn3ct Images/play-store.png";
// import FooterTop from "./KFooterTop";

// const socials = [
//   { icon: FacebookIcon, url: "https://facebook.com/konn3ctapp" },
//   { icon: TwitterIcon, url: "https://x.com/konn3ctapp" },
//   { icon: LinkedInIcon, url: "https://linkedin.com/in/YourPage" },
//   { icon: InstagramIcon, url: "https://www.instagram.com/konn3ctng" },
//   {
//     icon: YouTubeIcon,
//     url: "https://www.youtube.com/channel/UC6R90Zju7mJ0_pEZ5pBMA5w",
//   },
// ];

// const Footer = () => {
//   const [open, setOpen] = useState(null);
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const toggle = (section) => {
//     setOpen(open === section ? null : section);
//   };

//   return (
//     <div>
//       <FooterTop />

//       <footer className="relative bg-gradient-to-b from-[#03173f] to-[#2657B0] text-white font-sans pt-10 pb-24">

//         {/* Content wrapper */}
//         <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-20">

//           {/* MOBILE FIRST LAYOUT */}
//           <div className="md:hidden flex flex-col items-center text-center space-y-5">

//             {/* Logo */}
//             <img src={logo} alt="Konn3ct Logo" className="h-9" />

//             {/* Social Icons */}
//             <div className="flex gap-4">
//               {socials.map((s, i) => (
//                 <a key={i} href={s.url} target="_blank">
//                   <img src={s.icon} className="w-5 h-5" />
//                 </a>
//               ))}
//             </div>

//             {/* Address */}
//             <p className="text-gray-300 text-xs leading-5">
//               220B Eti-Osa Way, Dolphin Estate,<br />
//               Lagos 106104, Lagos
//             </p>

//             {/* ACCORDION SECTIONS */}
//             {/* Features */}
//             <div className="w-full">
//               <button
//                 onClick={() => setDropdownOpen(!dropdownOpen)}
//               className="flex items-center gap-1 text-white hover:text-[#1A4699] transition font-medium"
//             >
//                 Features
// <ChevronDown
//                 size={16}
//                 className={`transition-transform duration-200 ${
//                   dropdownOpen ? "rotate-180" : ""
//                 }`}
//               />
//                      </button>

//               {dropdownOpen && (
//                 <ul className="text-gray-300 text-sm space-y-2 pl-2 pb-3">
//                   <li>Konn3ct AI</li>
//                   <li>Donations</li>
//                   <li>Breakout rooms</li>
//                   <li>Live captions</li>
//                   <li>Translations</li>
//                   <li>eCinema</li>
//                   <li>Audio booster</li>
//                   <li>Whiteboard</li>
//                   <li>Playback</li>
//                   <li>Notetaker</li>
//                 </ul>
//               )}
//             </div>

//             {/* How To */}
//             <div className="w-full">
//               <button
//                 onClick={() => toggle("howto")}
//                 className="flex justify-between w-full py-3 font-semibold"
//               >
//                 How To <span>{open === "howto" ? "-" : "+"}</span>
//               </button>

//               {open === "howto" && (
//                 <ul className="text-gray-300 text-sm space-y-2 pl-2 pb-3">
//                   <li>Use Konn3ct</li>
//                   <li>Manage Konn3ct Room</li>
//                   <li>Join Konn3ct Room</li>
//                   <li>Use Konn3ct USPs</li>
//                   <li>Use Konn3ct AI</li>
//                   <li>Use Live Caption</li>
//                   <li>Make Donations</li>
//                 </ul>
//               )}
//             </div>

//             {/* Explore */}
//             <div className="w-full">
//               <button
//                 onClick={() => toggle("explore")}
//                 className="flex justify-between w-full py-3 font-semibold"
//               >
//                 Explore <span>{open === "explore" ? "-" : "+"}</span>
//               </button>

//               {open === "explore" && (
//                 <ul className="text-gray-300 text-sm space-y-2 pl-2 pb-3">
//                   <li>Customer</li>
//                   <li>Pricing</li>
//                   <li>Developer</li>
//                 </ul>
//               )}
//             </div>

//             {/* Company */}
//             <div className="w-full">
//               <button
//                 onClick={() => toggle("company")}
//                 className="flex justify-between w-full py-3 font-semibold"
//               >
//                 Company <span>{open === "company" ? "-" : "+"}</span>
//               </button>

//               {open === "company" && (
//                 <ul className="text-gray-300 text-sm space-y-2 pl-2 pb-3">
//                   <li>Terms of Use</li>
//                   <li>Privacy Policy</li>
//                   <li>NITDA</li>
//                 </ul>
//               )}
//             </div>

//             {/* Contact */}
//             <div className="w-full">
//               <button
//                 onClick={() => toggle("contact")}
//                 className="flex justify-between w-full py-3 font-semibold"
//               >
//                 Contact <span>{open === "contact" ? "-" : "+"}</span>
//               </button>

//               {open === "contact" && (
//                 <p className="text-gray-300 text-sm pl-2 pb-3">
//                   info@konn3ct.com
//                 </p>
//               )}
//             </div>

//             {/* App Buttons */}
//             <div className="flex flex-col gap-3 w-full">
//               <a className="bg-white text-black py-2 rounded-lg flex items-center justify-center gap-2">
//                 <img src={AppleIcon} className="w-5" />
//                 Get on iPhone
//               </a>

//               <a className="bg-white text-black py-2 rounded-lg flex items-center justify-center gap-2">
//                 <img src={PlayStoreIcon} className="w-5" />
//                 Get on Android
//               </a>
//             </div>

//           </div>

//           {/* DESKTOP LAYOUT — unchanged */}
//           <div className="hidden md:grid md:grid-cols-6 gap-8 mt-10 text-sm">
//             {/* your original desktop layout stays the same */}
//           </div>

//           {/* COPYRIGHT */}
//           <p className="text-center text-xs text-gray-400 mt-10">
//             © 2025 konn3ct • All Rights Reserved.
//           </p>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default Footer;

import React from "react";
import { Link } from "react-router-dom";
import logo from "../Images/Konn3ct Images/Konn3ct_lo-removed.png";
import FacebookIcon from "../Images/Konn3ct Images/facebook-02.png";
import TwitterIcon from "../Images/Konn3ct Images/new-twitter.png";
import LinkedInIcon from "../Images/Konn3ct Images/linkedin-01.png";
import InstagramIcon from "../Images/Konn3ct Images/instagram.png";
import YouTubeIcon from "../Images/Konn3ct Images/youtube.png";
// import AppleIcon from "../Images/Konn3ct Images/apple.png";
import PlayStoreIcon from "../Images/Konn3ct Images/play-store.png";
import FooterTop from "./KFooterTop";

const socials = [
  { icon: FacebookIcon, url: "https://facebook.com/konn3ctapp" },
  { icon: TwitterIcon, url: "https://x.com/konn3ctapp" },
  { icon: LinkedInIcon, url: "https://linkedin.com/in/konnectng" },
  { icon: InstagramIcon, url: "https://www.instagram.com/konn3ct_app" },
  {
    icon: YouTubeIcon,
    url: "https://www.youtube.com/channel/UC6R90Zju7mJ0_pEZ5pBMA5w",
  },
];

const Footer = () => {
  return (
    <div>
      <FooterTop />

      <footer className="relative bg-gradient-to-b from-[#03173f] to-[#2657B0] text-white font-sans pt-6 pb-4">
        {/* Grid pattern */}
        <div
          className="absolute inset-0 z-10"
          style={{
            backgroundImage: `
              repeating-linear-gradient(to right, rgba(255,255,255,0.08) 0, rgba(255,255,255,0.08) 1px, transparent 1px, transparent 80px),
              repeating-linear-gradient(to bottom, rgba(255,255,255,0.08) 0, rgba(255,255,255,0.08) 1px, transparent 1px, transparent 120px)
            `,
          }}
        />

        {/* Bottom fade overlay */}
        <div
          className="absolute inset-0 z-10 pointer-events-none"
          style={{
            background:
              "linear-gradient(to bottom, rgba(0,0,0,0) 60%, rgba(0,0,0,1) 100%)",
            maskImage:
              "linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0))",
            WebkitMaskImage:
              "linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0))",
          }}
        />

        {/* Main footer content */}
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-8 relative z-20">
          <div className="grid grid-cols-1 md:grid-cols-6 gap-8 text-sm">
            {/* Logo & Socials */}
            <div className="space-y-4 md:col-span-1">
              <img src={logo} alt="Konnect Logo" className="h-8 w-auto" />

              <div className="flex gap-3 mb-4">
                {socials.map((item, i) => (
                  <a
                    key={i}
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={item.icon}
                      alt="social"
                      className="w-6 h-6 cursor-pointer hover:opacity-80"
                    />
                  </a>
                ))}
              </div>

              <address className="text-gray-300 leading-6 not-italic text-xs">
                220B Et-Osa Way, Dolphin <br /> Estate, Lagos 106104, Lagos
              </address>
            </div>

            {/* Features */}
            <nav aria-label="Features">
              <h3 className="font-semibold mb-3">Features</h3>
              <ul className="space-y-2 text-gray-300">
                <li>
                  <Link to="/Features" className="hover:text-white transition">
                    Konn3ct AI
                  </Link>
                </li>

                <li>
                  <Link to="/Features" className="hover:text-white transition">
                    Donations
                  </Link>
                </li>

                <li>
                  <Link to="/Features" className="hover:text-white transition">
                    Breakout rooms
                  </Link>
                </li>

                <li>
                  <Link to="/Features" className="hover:text-white transition">
                    Live captions
                  </Link>
                </li>

                <li>
                  <Link to="/Features" className="hover:text-white transition">
                    Translations
                  </Link>
                </li>

                <li>
                  <Link to="/Features" className="hover:text-white transition">
                    eCinema
                  </Link>
                </li>

                <li>
                  <Link to="/Features" className="hover:text-white transition">
                    Audio booster
                  </Link>
                </li>

                <li>
                  <Link to="/Features" className="hover:text-white transition">
                    Whiteboard
                  </Link>
                </li>

                <li>
                  <Link to="/Features" className="hover:text-white transition">
                    Playback
                  </Link>
                </li>

                <li>
                  <Link to="/Features" className="hover:text-white transition">
                    Notetaker
                  </Link>
                </li>
              </ul>
            </nav>

            {/* How To */}
            <nav aria-label="How To">
              <h3 className="font-semibold mb-3">How To</h3>
              <ul className="space-y-2 text-gray-300">
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=eTFcF4cgNn0"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white"
                  >
                    Use Konn3ct
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.youtube.com/watch?v=4zWzblaEtH0"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white"
                  >
                    Manage Konn3ct Room
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.youtube.com/watch?v=TZgMfQBWeRk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white"
                  >
                    Join Konn3ct Room
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.youtube.com/watch?v=2NLv9vo06XI"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white"
                  >
                    Use Konn3ct USPs
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.youtube.com/watch?v=iCX4InX_vzE"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white"
                  >
                    Use Konn3ct AI
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.youtube.com/watch?v=iCX4InX_vzE"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white"
                  >
                    Use Live Caption
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.youtube.com/watch?v=Q0JNE0LDCnE"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white"
                  >
                    Make Donations
                  </a>
                </li>
              </ul>
            </nav>

            {/* Explore */}
            <nav aria-label="Explore">
              <h3 className="font-semibold mb-3">Explore</h3>
              <ul className="space-y-2 text-gray-300">
                <li>
                  <Link to="/Customers" className="hover:text-white transition">
                    Customer
                  </Link>
                </li>
                <li>
                  <Link to="/Pricing" className="hover:text-white transition">
                    Pricing
                  </Link>
                </li>
                <li>
                  <Link
                    to="/Konn3ctDevs"
                    className="hover:text-white transition"
                  >
                    Developer
                  </Link>
                </li>
              </ul>
            </nav>

            {/* Company */}
            <nav aria-label="Company">
              <h3 className="font-semibold mb-3">Company</h3>
              <ul className="space-y-2 text-gray-300">
                <li>
                  <Link to="/Konn3ctTC" className="hover:text-white transition">
                    Terms of Use
                  </Link>
                </li>
                <li>
                  <Link to="/Konn3ctPP" className="hover:text-white transition">
                    Privacy Policy
                  </Link>
                </li>
                {/* <li>NITDA</li> */}
              </ul>
            </nav>

            {/* Contact */}
            <div>
              <h3 className="font-semibold mb-3">Contact</h3>
              <a
                href="mailto:info@konn3ct.com"
                className="text-gray-300 hover:text-white"
              >
                info@konn3ct.com
              </a>
            </div>
          </div>

          {/* App download buttons */}
          <div className="flex justify-between items-center mt-12 relative">
            <div className="flex gap-4 ">
              {/* iPhone App Store Link */}
              {/* <a
                href="https://apps.apple.com/app/YOUR_APP_ID"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-black font-medium px-4 py-2 sm:py-1 sm:px-2 rounded-lg flex items-center gap-2"
              >
                <img src={AppleIcon} alt="Apple" className="w-5 h-5" />
                Get on iPhone
              </a> */}

              {/* Android Play Store Link */}
              <a
                href="https://play.google.com/store/apps/details?id=com.konn3ct&hl=en"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-black font-medium px-4 py-2 rounded-lg flex items-center gap-2"
              >
                <img src={PlayStoreIcon} alt="Play Store" className="w-5 h-5" />
                Get on Android
              </a>
            </div>
          </div>

          <p className="absolute bottom-4 left-1/2 -translate-x-1/2 text-xs text-gray-400 font-semibold">
            © 2026 Konn3ct • All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;

// import React from "react";
// import logo from "../Images/Konn3ct Images/Konn3ct_lo-removed.png";
// import FacebookIcon from "../Images/Konn3ct Images/facebook-02.png";
// import TwitterIcon from "../Images/Konn3ct Images/new-twitter.png";
// import LinkedInIcon from "../Images/Konn3ct Images/linkedin-01.png";
// import InstagramIcon from "../Images/Konn3ct Images/instagram.png";
// import YouTubeIcon from "../Images/Konn3ct Images/youtube.png";
// import AppleIcon from "../Images/Konn3ct Images/apple.png";
// import PlayStoreIcon from "../Images/Konn3ct Images/play-store.png";
// import Badge1 from "../Images/Konn3ct Images/G2UistvT_400x400 1.png";
// import Badge2 from "../Images/Konn3ct Images/G2UistvT_400x400 2.png";
// import FooterTop from "./KFooterTop";

// const Footer = () => {
//   return (
// <div>
//      <FooterTop />

//     <footer className="relative bg-gradient-to-b from-[#03173f] to-[#2657B0] text-white font-sans pt-6 pb-4">
//       <div
//         className="absolute inset-0 z-10"
//         style={{
//           backgroundImage: `
//             repeating-linear-gradient(to right, rgba(255,255,255,0.08) 0, rgba(255,255,255,0.08) 1px, transparent 1px, transparent 80px),
//             repeating-linear-gradient(to bottom, rgba(255,255,255,0.08) 0, rgba(255,255,255,0.08) 1px, transparent 1px, transparent 120px)
//           `,
//         }}
//       />
//       {/* Top icons row */}

//      <div
//   className="absolute inset-0 z-10 pointer-events-none"
//   style={{
//     background: 'linear-gradient(to bottom, rgba(0,0,0,0) 60%, rgba(0,0,0,1) 100%)',
//     maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0))',
//     WebkitMaskImage: 'linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0))',
//   }}
// />

//       {/* Main footer content */}
//       <div className="max-w-7xl mx-auto px-6 lg:px-12 py-8">
//         <div className="grid grid-cols-1 md:grid-cols-6 gap-8 text-sm space-x-4">
//           {/* Logo & Address */}
//           <div className="space-y-4 md:col-span-1 ">
//             <div className="flex items-center">
//               <img src={logo} alt="Konnect Logo" className="h-8 w-auto" />
//             </div>
//             {/* Social icons placeholder */}
//             <div className="flex gap-3 mb-4">
//               <img src={FacebookIcon} alt="Facebook" className="w-6 h-6" />
//               <img src={TwitterIcon} alt="Twitter" className="w-6 h-6" />
//               <img src={LinkedInIcon} alt="LinkedIn" className="w-6 h-6" />
//               <img src={InstagramIcon} alt="Instagram" className="w-6 h-6" />
//               <img src={YouTubeIcon} alt="YouTube" className="w-6 h-6" />
//             </div>

//             <address className="text-gray-300 leading-6 not-italic text-xs">
//               220B Et-Osa Way, Dolphin <br /> Estate, Lagos 106104, Lagos
//             </address>
//           </div>

//           {/* Features */}
//           <div>
//             <h3 className="font-semibold mb-3">Features</h3>
//             <ul className="space-y-2 text-gray-300">
//               <li>Konn3ct AI</li>
//               <li>Donations</li>
//               <li>Breakout rooms</li>
//               <li>Live captions</li>
//               <li>Translations</li>
//               <li>eCinema</li>
//               <li>Audio booster</li>
//               <li>Whiteboard</li>
//               <li>Playback</li>
//               <li>Notetaker</li>
//             </ul>
//           </div>

//           {/* How To */}
//           <div>
//             <h3 className="font-semibold mb-3">How To</h3>
//             <ul className="space-y-2 text-gray-300">
//               <li>Use konn3ct</li>
//               <li>Join Breakout Room</li>
//               <li>Create Breakout Room</li>
//               <li>Use Konne3ct AI</li>
//               <li>Use Live Caption</li>
//             </ul>
//           </div>

//           {/* Explore */}
//           <div>
//             <h3 className="font-semibold mb-3">Explore</h3>
//             <ul className="space-y-2 text-gray-300">
//               <li>Customer</li>
//               <li>Pricing</li>
//               <li>Developer</li>
//             </ul>
//           </div>

//           {/* Company */}
//           <div>
//             <h3 className="font-semibold mb-3">Company</h3>
//             <ul className="space-y-2 text-gray-300">
//               <li>Terms of Use</li>
//               <li>Privacy Policy</li>
//               <li>NDPR</li>
//               <li>GDPR</li>
//             </ul>
//           </div>

//           {/* Contact */}
//           <div>
//             <h3 className="font-semibold mb-3">Contact</h3>
//             <p className="text-gray-300">info@konn3ct.com</p>
//           </div>
//         </div>

//         {/* App download buttons */}
//         <div className="flex flex-col md:flex-row items-center justify-center gap-4 mt-10 ">
//           {/* App download buttons */}
//           <div className="flex flex-col sm:flex-row items-center gap-4 mt-8 absolute bottom left-6">
//             {/* <div className="flex flex-wrap justify-start gap-4 mt-8"> */}
//             <button className="bg-white text-black font-medium px-4 py-2 rounded-lg flex items-center gap-2 ">
//               <img src={AppleIcon} alt="iPhone" className="w-5 h-5" />
//               Get on iPhone
//             </button>

//             <button className="bg-white text-black font-medium px-4 py-2 rounded-lg flex items-center gap-2">
//               <img src={PlayStoreIcon} alt="Android" className="w-5 h-5" />
//               Get on Android
//             </button>
//           </div>

//           {/* <div className="flex items-center gap-6 mt-4 md:mt-0 ml-0 md:ml-6"> */}
//           <div className="absolute bottom right-6 flex flex-row items-center gap-3">
//             <img src={Badge1} alt="iPhone" className="w-12 h-12" />
//             {/* First image placeholder */}
//             <img src={Badge2} alt="playstore" className="w-12 h-12" />
//             {/* Second image placeholder */}
//           </div>
//         </div>
//         {/* Copyright */}
//         <div className="text-center text-gray-400 text-xs mt-8 border-t border-gray-500/30 pt-4">
//           © 2025 konn3ct • All Rights Reserved
//         </div>
//       </div>
//     </footer>
//     </div>
//   );
// };

// export default Footer;

// import React from "react";
// import { FaInstagram, FaTwitter, FaLinkedin, FaYoutube, FaFacebook } from "react-icons/fa";
// import { MdSupportAgent } from "react-icons/md";
// import { BsShieldCheck, BsClockHistory } from "react-icons/bs";
// import { RiSignalWifiFill } from "react-icons/ri";

// const Footer = () => {
//   return (
//     <footer className="relative min-h-screen bg-gradient-to-b from-[#03173f] to-[#2657B0] text-white font-sans pt-6 pb-4">
//     {/* // className="bg-gradient-to-b from-[#0B2A7E] to-[#05194B] text-white pt-6 pb-4"> */}
//       {/* Top Info Bar */}
//       <div
//         className="absolute inset-0"
//         style={{
//           backgroundImage: `
//             repeating-linear-gradient(to right, rgba(255,255,255,0.08) 0, rgba(255,255,255,0.08) 1px, transparent 1px, transparent 80px),
//             repeating-linear-gradient(to bottom, rgba(255,255,255,0.08) 0, rgba(255,255,255,0.08) 1px, transparent 1px, transparent 120px)
//           `,
//         }}
//       />
//       <div className="flex flex-wrap justify-center md:justify-between items-center border-b border-r border-white/20 px-6 py-3 text-sm bg-white">
//         <div className="flex items-center gap-2 mb-2 md:mb-0">
//           <MdSupportAgent className="text-white" />
//           <span>24/7 Support</span>
//         </div>
//         <div className="flex items-center gap-2 mb-2 md:mb-0">
//           <BsClockHistory className="text-white" />
//           <span>Changelog</span>
//         </div>
//         <div className="flex items-center gap-2 mb-2 md:mb-0">
//           <BsShieldCheck className="text-white" />
//           <span>Secure and compliant</span>
//         </div>
//         <div className="flex items-center gap-2">
//           <RiSignalWifiFill className="text-white" />
//           <span>99.9% uptime</span>
//         </div>
//       </div>

//       {/* Main Footer */}
//       <div className="container mx-auto grid grid-cols-2 md:grid-cols-6 gap-6 text-sm px-6 py-10">
//         {/* Logo & Address */}
//         <div className="col-span-2">
//           <h2 className="text-2xl font-semibold mb-3">konn3ct</h2>
//           <div className="flex gap-3 text-lg mb-4">
//             <FaInstagram />
//             <FaTwitter />
//             <FaLinkedin />
//             <FaYoutube />
//             <FaFacebook />
//           </div>
//           <p className="text-gray-200 leading-relaxed">
//             220B Eti-Osa Way, Dolphin Estate, Lagos 106104, Lagos
//           </p>
//         </div>

//         {/* Features */}
//         <div>
//           <h3 className="font-semibold mb-3">Features</h3>
//           <ul className="space-y-1 text-gray-300">
//             <li>Konn3ct AI</li>
//             <li>Donations</li>
//             <li>Breakout rooms</li>
//             <li>Live captions</li>
//             <li>Translations</li>
//             <li>eCinema</li>
//             <li>Audio booster</li>
//             <li>Whiteboard</li>
//             <li>Playback</li>
//             <li>Notetaker</li>
//           </ul>
//         </div>

//         {/* How To */}
//         <div>
//           <h3 className="font-semibold mb-3">How To</h3>
//           <ul className="space-y-1 text-gray-300">
//             <li>Use konn3ct</li>
//             <li>Join Breakout Room</li>
//             <li>Create Breakout Room</li>
//             <li>Use Konn3ct AI</li>
//             <li>Use Live Caption</li>
//           </ul>
//         </div>

//         {/* Explore */}
//         <div>
//           <h3 className="font-semibold mb-3">Explore</h3>
//           <ul className="space-y-1 text-gray-300">
//             <li>Customer</li>
//             <li>Pricing</li>
//             <li>Developer</li>
//           </ul>
//         </div>

//         {/* Company */}
//         <div>
//           <h3 className="font-semibold mb-3">Company</h3>
//           <ul className="space-y-1 text-gray-300">
//             <li>Terms of Use</li>
//             <li>Privacy Policy</li>
//             <li>NDPR</li>
//             <li>GDPR</li>
//           </ul>
//         </div>

//         {/* Contact */}
//         <div>
//           <h3 className="font-semibold mb-3">Contact</h3>
//           <ul className="space-y-1 text-gray-300">
//             <li>info@konn3ct.com</li>
//           </ul>
//         </div>
//       </div>

//       {/* App Store Buttons */}
//       <div className="flex justify-center gap-4 mt-2 mb-4">
//         <button className="bg-white text-black px-4 py-2 rounded-md flex items-center gap-2 text-sm font-semibold shadow-md hover:opacity-90">
//           <img
//             src="https://upload.wikimedia.org/wikipedia/commons/3/31/Apple_logo_white.svg"
//             alt="Apple"
//             className="h-4 w-4 bg-black p-1 rounded"
//           />
//           Get on iPhone
//         </button>
//         <button className="bg-white text-black px-4 py-2 rounded-md flex items-center gap-2 text-sm font-semibold shadow-md hover:opacity-90">
//           <img
//             src="https://upload.wikimedia.org/wikipedia/commons/d/d0/Google_Play_Arrow_logo.svg"
//             alt="Google Play"
//             className="h-4 w-4"
//           />
//           Get on Android
//         </button>
//       </div>

//       {/* Bottom Copyright */}
//       <div className="text-center text-xs text-gray-300 border-t border-white/10 pt-3">
//         © 2025 konn3ct · All Rights Reserved
//       </div>
//     </footer>
//   );
// };

// export default Footer;
